// extracted by mini-css-extract-plugin
export default {"form":"flWCif","inputField":"vR6uMc","fieldLabel":"dFg1m9"};